export default __webpack_public_path__ + "static/media/DINERS_CLUB.adcaf9bd.png";